
import api from '~api'
import setting from '../../../server/settings'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

export default {
name: "delay",
components: {
XHeader,Group,Selector,XInput,Toast
},
data() {
return {
baseurl: setting.api_root+ '/api/greenchannel/imgLook?params=',
imageUrl1: "",
imageUrl2: "",
title: "建档立卡",
stuinfo:{},
state:0,
reduceinfo:{},
showtoast:false,
toasttext:'',
relations: [{
key: '1',
value: '建档立卡'
}],
statusArray: [{
key: '0',
value: '未审核'
}, {
key: '1',
value: '审核通过'
}, {
key: '2',
value: '审核不通过'
}],
}
},
mounted(){
api.post("/api/NewReports/findInformation",{"stuCode": this.$route.params.stunum}).then( res=>{
if(res.status==200){
this.stuinfo = res.data.results[0];
if(this.stuinfo.gender=="1"){
this.$set(this.stuinfo,"sex","男")
}else{
this.$set(this.stuinfo,"sex","女")
}
}
})
this.getData()

},
methods:{
getData(){
const param = {
"stuCode": this.$route.params.stunum,
"year": this.$route.params.year,
}
api.post("/api/greenChannelAudit/selectJdlkMsg",param).then( res=>{
if(res.data.msg && res.data.msg.length > 0 ){
this.reduceinfo = res.data.msg[0];
this.state = 2;
}else{
this.state = 0;
}
})
},
backPage(){
this.$router.push({name:'checkReduce'})
},
changeCheck(){
console.log(this.reduceinfo.status)
if(this.reduceinfo.status == '' || this.reduceinfo.status ==null || this.reduceinfo.status == '0'){
this.toasttext = "请选择审核状态";
this.showtoast=true;
return false;
}
return true;
},
goedit(){
if(this.changeCheck()){
this.$vux.loading.show({
text: '加载中，请稍候！'
})
var param = {
'status': this.reduceinfo.status,
'userId': window.localStorage.getItem("userId"),
'stuCode': this.$route.params.stunum,
'reason': this.reduceinfo.reason,
'auditType': this.reduceinfo.auditType,
'year': this.reduceinfo.year,
'verifyId': this.reduceinfo.verifyId,
};
api.post("/api/greenChannelAudit/updateStatus", param).then( res=>{
if(res.status==200){
if(res.data.results=='1'){
this.$router.push({name:'checkReduce'})
}else{
this.$msgbox('温馨提示：',"申请审核失败！");
}
}
this.$vux.loading.hide()
})

}
},
}
}



// WEBPACK FOOTER //
// ./src/components/audit/reduceDetile.vue